import React, { type ForwardedRef, forwardRef } from 'react'
import classNames from 'classnames'
import styles from './LayoutCluster.module.css'
import { CommonLayoutClusterProps, LayoutClusterProps } from './types'

const LayoutCluster = forwardRef(function LayoutCluster(
  {
    as: Tag = 'div',
    alignment = 'clustered',
    justify = 'start',
    container,
    className,
    flex,
    wrap = true,
    space = '200',
    style,
    align,
    ...props
  }: LayoutClusterProps,
  ref: ForwardedRef<HTMLElement>
) {
  return (
    <Tag
      {...(props as Extract<typeof props, CommonLayoutClusterProps>)}
      className={classNames(styles.cluster, className, {
        [styles.justified!]: alignment === 'justified',
        [styles.clustered!]: alignment === 'clustered',
        [styles.justifyStart!]: justify === 'start',
        [styles.justifyEnd!]: justify === 'end',
        [styles.justifyCenter!]: justify === 'center',
        [styles.justifySpaceAround!]: justify === 'space-around',
        [styles.justifySpaceBetween!]: justify === 'space-between',
        [styles.alignStart!]: align === 'start',
        [styles.alignEnd!]: align === 'end',
        [styles.alignCenter!]: align === 'center',
        [styles.container!]: container,
        [styles.flex!]: flex,
        [styles.noWrap!]: !wrap,
      })}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
      ref={ref as any}
      style={
        {
          ...style,
          '--space': `var(--betterplace-spacing-${space})`,
        } as React.CSSProperties
      }
    >
      {props.children}
    </Tag>
  )
})

export default LayoutCluster
